import { useStaticQuery, graphql } from "gatsby";
import { FixedObject } from "gatsby-image";
import { HowItWorksQuery } from "../../../../graphql-types";
import { pp } from "../../../shared/utilities/pretty-print";
import { HowItWorksProps } from "../HowItWorks";

function useHowItWorksQuery() {
  const data = useStaticQuery(graphql`
    query HowItWorks {
      staticImagesJson {
        images {
          howItWorksStepOne {
            fixed(height: 130) {
              ...CloudinaryAssetFixed_noBase64
            }
          }
          howItWorksStepTwo {
            fixed(height: 130) {
              ...CloudinaryAssetFixed_noBase64
            }
          }
          howItWorksStepThree {
            fixed(height: 130) {
              ...CloudinaryAssetFixed_noBase64
            }
          }
        }
      }
    }
  `) as HowItWorksQuery;

  return data;
}

export function useHowItWorksProps() {
  const data = useHowItWorksQuery();

  if (data.staticImagesJson?.images?.howItWorksStepOne?.fixed == null) {
    throw Error(
      `data.staticImagesJson?.images?.howItWorksStepOne?.fixed is null: ` +
        `${pp({ data })}`
    );
  }
  if (data.staticImagesJson?.images?.howItWorksStepTwo?.fixed == null) {
    throw Error(
      `data.staticImagesJson?.images?.howItWorksStepTwo?.fixed is null: ` +
        `${pp({ data })}`
    );
  }
  if (data.staticImagesJson?.images?.howItWorksStepThree?.fixed == null) {
    throw Error(
      `data.staticImagesJson?.images?.howItWorksStepThree?.fixed: ` +
        `${pp({ data })}`
    );
  }
  const stepOneFixed = data.staticImagesJson.images.howItWorksStepOne
    .fixed as FixedObject;
  const stepTwoFixed = data.staticImagesJson.images.howItWorksStepTwo
    .fixed as FixedObject;
  const stepThreeFixed = data.staticImagesJson.images.howItWorksStepThree
    .fixed as FixedObject;

  const howItWorksProps: HowItWorksProps = {
    stepOneFixed,
    stepTwoFixed,
    stepThreeFixed,
  };

  return howItWorksProps;
}
